module.exports = __webpack_public_path__ + "static/media/kia_blanco.74bbf06e.png";